import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteSeoConfig, setPageSeo } from '../../utils/seo';

function SeoRouteManager() {
  const location = useLocation();

  useEffect(() => {
    const seoConfig = getRouteSeoConfig(location.pathname);
    setPageSeo(seoConfig);
  }, [location.pathname]);

  return null;
}

export default SeoRouteManager;
